/**
 * トップ画面
*/
import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import asyncService from "../../services/common/asyncService";
import authService from "../../services/common/authService";
import stateStore from "../../store/stateStore";
import IsdPassword from "../common/isdPassword";
import IsdTextBox from "../common/isdTextBox";
import { observer } from "mobx-react";
import dialogService from "../../services/common/dialogService";
//import logo from "../../images/torizenLogo.jpg"
import logo from "../../images/torizenLogo.png"
import rootScope from "../../store/rootScopeStore";
import { goto } from "../../util/isd-utils";
import { getMsg, isEmpty, isNotEmpty } from "../../util/util";
import sessionStore from "../../store/sessionStore";
import pocs from "../../services/pocs";
import jyuService from "../../services/jyu/jyuService";
import { param } from "jquery";
import axios from "axios";

// 動作監視用
const Jyuf101 = observer(() => {
    const dispatch = useDispatch();
    const refTksakicd = useRef();
    const refUserid = useRef();

    useEffect(() => {
        stateStore.state = {
            tksakicd: "",
            userid: "",
            passwordInput: ""
        };
    }, []);

    // サインインイベント
    const SingleSignOn = () => {
        // ssoリクエスト
        window.location.href = window.location.origin + "/sasuga-mobile-api-torizen/api/login/sso";
    }

    return (
        <div className="logincontainer">
            <div className="loginCard mx-auto mt-5">
                <div className="loginTitle">
                    <img src={logo} />
                </div>
                <div className="loginForm">
                    
                    <button className="btn btn-login mt-3" onClick={SingleSignOn}>ログイン</button>
                </div>
                <div className="mt-4 login-btn-refer" >
                    <button className="btn btn-danger btn-regist-first mt-3" onClick={() => { goto('Jyuf102') }}>初回利用のためログイン情報を申請する
                        <div className="icon-regist-first"></div>
                    </button>
                </div>
            </div>
        </div>
    )
})
export default Jyuf101;